<template>
  <v-flex xs12>
    <v-card>
      <v-flex xs12 pt-4 pb-2 px-4 v-if="err">
        <v-alert :value="true" type="error"> {{err}}</v-alert>
      </v-flex>
      <v-flex xs12 pt-4 pb-2 px-4 v-if="success">
        <v-alert type="success" :value="true">{{success}}</v-alert>
      </v-flex>
      <v-card-title class="pb-3 px-2 layout row wrap">
        <v-btn
          class="primary my-0 mx-3"
          type="button"
          @click="createCatalog">
          {{$lang.actions.createCatalog}}
        </v-btn>
        <v-checkbox
          color="primary"
          class="mx-1 mt-0"
          :label="$lang.labels.showActive"
          v-model="showActive"
          hide-details
        />
        <v-spacer />
        <v-autocomplete
          v-if="!isLocalAdmin"
          class="min-w max-w mx-3 pb-2"
          :label="$lang.actions.selectCompany"
          :items="mappedCompanies"
          v-model="selectedCompany"
          hide-details
        />
      </v-card-title>
      <div v-if="selectedCompany || (isLocalAdmin && allCatalogs)">
        <transition name="fade">
          <v-data-table
            :items="showActive ? activeCatalogs : allCatalogs"
            :headers="headers"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
          >
            <v-progress-linear height="6" slot="progress" color="primary" indeterminate/>
            <template slot="items" slot-scope="props">
              <td>{{props.item.catalogVersion}}</td>
              <td>{{props.item.catalogName}}</td>
              <td>{{ formatDateWithTime(props.item.createdOn) }}</td>
              <td>{{props.item.status}}</td>
              <td style="min-width: 340px;">
                <v-btn color="primary" :loading="props.item.activating" v-if="props.item.status !== 'active'" class="mx-0" @click.stop="activateCatalog(props.item)">{{ $lang.actions.activate }}</v-btn>
                <v-btn color="primary" @click="editCatalog(props.item.catalogId)">{{ $lang.actions.copyEdit }}</v-btn>
                <v-btn
                  v-if="$auth.roles.includes('ROLE_SUN_ADMIN_CATALOG')"
                  color="primary"
                  class="ml-0"
                  @click="pushToCorp(props.item.catalogId)">
                  {{ $lang.actions.pushToCorp }}
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </transition>
      </div>
    </v-card>
    <v-dialog v-if="showActivationModal" v-model="showActivationModal" max-width="500">
      <activation-modal :data="activationData" @close="closeActivation($event)"/>
    </v-dialog>
    <v-dialog v-if="confirmPushModal" persistent v-model="confirmPushModal" max-width="500">
      <confirm-push :id="catalogId" @close="confirmPushModal = false"/>
    </v-dialog>
  </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';
  import * as fetch_data from '../../assets/fetch_data';
  import {baseUrl} from '../../assets/url';

  export default {
    data() {
      return {
        err: '',
        success: '',
        selectedCompany: null,
        isLocalAdmin: false,
        companies: [],
        loading: false,
        language: this.$cookie.get('lang') || 'en',
        headers: [
          {text: this.$lang.header.catalogVersion, value: 'catalogVersion', align: 'left'},
          {text: this.$lang.header.catalogName, value: 'catalogName', align: 'left'},
          {text: this.$lang.labels.created, value: 'createdOn', align: 'left'},
          {text: this.$lang.labels.status, value: 'status', align: 'left'},
          {text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false},
        ],
        allCatalogs: [],
        showActive: true,
        pagination: {
          sortBy: 'catalogVersion',
          descending: true,
        },
        showActivationModal: false,
        activationData: null,
        confirmPushModal: false,
        catalogId: '',
      };
    },
    watch: {
      selectedCompany(val) {
        this.fetchCatalogsForCompany(val);
        this.$cookie.set('companyedit', val, { expires: '8h' });
      },
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    computed: {
      activeCatalogs() {
        const catalogs = this.allCatalogs;
        const activeCatalogs = [];
        for (let i=0; catalogs.length > i; i++) {
          if (catalogs[i].status === 'active' || catalogs[i].status === 'created') {
            activeCatalogs.push(catalogs[i]);
          }
        }
        return activeCatalogs;
      },
      mappedCompanies() {
        return this.companies.map(company => ({
          text: `${company.name} (${company.companyStatus})`,
          value: company.id,
        }));
      },
    },
    methods: {
      pushToCorp(id) {
        console.log('clicked');
        this.catalogId = id;
        this.confirmPushModal = true;
      },
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd');
      },
      formatDateWithTime(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm');
      },
      fetchCatalogsForCompany(companyId) {
        this.loading = true;
        this.allCatalogs = [];
        this.activeCatalogs = [];
        this.$http.post('catalog/getcatalogversions', { companyId })
          .then((res) => {
            if (res.body.status === 'Success') {
              this.loading = false;
              this.allCatalogs = res.body.details.map(catalog => ({...catalog, activating: false}));
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.loading = false;
            this.err = err.body.statusText || err.body.message;
        });
      },
      editCatalog(id) {
        this.$router.push({ name: "catalogCreate", query: {id: id}, params: { id: id } });
      },
      createCatalog() {
        this.$router.push({name: "catalogCreate", params: {companies: this.companies}})
      },
      getWebshopView(views) {
        let webview;
        views.forEach((view) => {
          if (view.name.en === 'Webshop') webview = view;
        });
        return webview;
      },
      closeActivation(data) {
        this.showActivationModal = false;
        this.activationData = null;
        if (data) {
          this.fetchCatalogsForCompany(this.selectedCompany);
        }
      },
      activateCatalog(catalog) {
        this.activationData = {
          catalogId: catalog.catalogId,
          catalogVersion: catalog.catalogVersion,
          companyId: this.selectedCompany,
        }
        this.$set(catalog, 'activating', true);
        this.$http.get(`catalog/${catalog.catalogId}`)
          .then((res) => {
            const webview = this.getWebshopView(res.body.catalog.views);
            if (!webview) return null;
            this.activationData.catalogViewId = webview.viewId;
            return this.$http.post('webshopresource/getall', { companyId: this.selectedCompany });
          })
          .then((res) => {
            if (res && res.body.status === 'Success') {
              this.activationData.webshops = res.body.details.filter(webshop => webshop.status === 'active');
            }
            this.$set(catalog, 'activating', false);
            this.showActivationModal = true;
          })
          .catch((e) => {
            this.activationData = null;
            this.$set(catalog, 'activating', false);
            this.err = e.message || e.body.message;
          });
        // this.fetchCatalogsForCompany(this.selectedCompany);
      },
    },
    created() {
      this.isLocalAdmin = this.$auth.roles && this.$auth.roles.includes('ROLE_SUN_LOCAL_ADMIN');
      if (this.isLocalAdmin) {
        this.fetchCatalogsForCompany();
        return;
      }
      this.$http.get('company')
        .then((res) => {
          if (res.body.status === 'Success') {
            this.companies = res.body.companies;
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
      const edit = this.$cookie.get('companyedit');
      if (edit) this.selectedCompany = edit;
    },
    components: {
      activationModal: () => import('../modals/CatalogActivationModal'),
      confirmPush: () => import('../modals/PushToCorp'),
    },
  };
</script>



// WEBPACK FOOTER //
// List.vue?5dec1888